<template>
  <div class="mdc-layout-grid__cell">
    <div class="mdc-typography mdc-typography--headline">
      {{title}}
    </div>
    <div class="mdc-typography mdc-typography--body1">
      {{text}}
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      title () {
        return 'Advena de brevis lixa, dignus uria!'
      },
      text () {
        return 'Walk wihtout voyage, and we won’t evacuate an emitter. It is a twisted definition, sir.'
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Post.vue?6fdd78c6